var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"stroke":"#525D70","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M4 2.668v4a4 4 0 1 0 8 0v-4M2.667 13.335h10.667"}})])
}
var staticRenderFns = []

export default { render: render }